export default __webpack_public_path__ + "static/media/view.abb143c2.svg";